import { auditReports } from '@mi-front/api-clients';
import { MrtTable, SwitchInput } from '@mi-front/ui';
import { Box, Paper } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { FormattedMessage } from 'react-intl';
import { useGipReportResultFilter_v2 } from './useGipReportResultFilter';
import { useGipResultColumnsFactory } from './useGipResultColumnsFactory';

interface Props {
  schedules: auditReports.GipReportMatchedScheduleDto[];
}

export const GipReportMatchedSchedulesView = ({ schedules }: Props) => {
  const columns = useGipResultColumnsFactory();

  const { showOffTolerance, setShowOffTolerance, filteredItems } =
    useGipReportResultFilter_v2(schedules);

  const tableColumns = [
    columns.station,
    columns.date,
    columns.time,
    columns.advertiser,
    columns.campaign,
    columns.version,
    columns.customId,
    columns.duration,
    columns.contract,
    columns.order,
    columns.actions,
    columns.offToleranceIndicator,
  ] as unknown as MRT_ColumnDef<auditReports.GipReportMatchedScheduleDto>[];

  return (
    <>
      <Paper>
        <Box p={1} mb={2} mt={2}>
          <SwitchInput size="sm" checked={showOffTolerance} onChange={setShowOffTolerance} />{' '}
          <FormattedMessage
            id="audit.gipReport.result.showOffTolerance"
            defaultMessage="Mostrar resultados fuera de tolerancia"
          />
        </Box>
      </Paper>

      <MrtTable<auditReports.GipReportMatchedScheduleDto>
        data={filteredItems}
        columns={tableColumns}
        muiTableBodyCellProps={({ row }) => {
          const match = row.original.match;

          const classes =
            match?.matchedScheduleConfirmationType === 'OFF_TOLERANCE' ? 'text-yellow' : '';

          return {
            classes: {
              root: classes,
            },
          };
        }}
      />
    </>
  );
};
